(function ($, window) {
    let prodigy_product_gallery = {

        swiperThumbs: false,
        swiperMain: false,
        main_slider_template: '#gallery-slide',
        thumb_slider_template: '#gallery-thumbs-slide',
        is_variant_gallery: false,

        init: function () {
            this.set_product_gallery();
        },

        set_product_gallery: function (min_lenth = 3) {
            let thumbsDirection = 'horizontal';
            let thumbsSlidesPerView = $('#gallery-thumbs').data('slides') || min_lenth;
            let thumbsSpaceBetween = $('#gallery-thumbs').data('spacing') || 10;

            if ($('#gallery').hasClass('prodigy-product__gallery-container--left') || $('#gallery').hasClass('prodigy-product__gallery-container--right')) {
                const ratio = $('#gallery-main').data('ratio');
                const width = $('#gallery-main').width();
                const height = width / ratio;
                $('#gallery').height(height);
                thumbsDirection = 'vertical';
                thumbsSlidesPerView = 'auto';
            }

            const initNav = (swiper, el) => {
                // Remove old handlers before adding new ones
                el.off('click', '.prodigy-product__gallery-nav-prev');
                el.off('click', '.prodigy-product__gallery-nav-next');
                
                el.on(
                    'click',
                    '.prodigy-product__gallery-nav-prev',
                    function () {
                        if (swiper && swiper.params && !swiper.destroyed) {
                            if (swiper.isBeginning) {
                                swiper.slideTo(swiper.slides.length - 1);
                            } else {
                                swiper.slidePrev();
                            }
                        }
                    },
                );
                el.on(
                    'click',
                    '.prodigy-product__gallery-nav-next',
                    function () {
                        if (swiper && swiper.params && !swiper.destroyed) {
                            if (swiper.isEnd) {
                                swiper.slideTo(0);
                            } else {
                                swiper.slideNext();
                            }
                        }
                    },
                );
            };

            this.swiperThumbs = new Swiper(
                '#gallery-thumbs',
                {
                    direction: thumbsDirection,
                    slidesPerView: thumbsSlidesPerView,
                    spaceBetween: thumbsSpaceBetween,
                    speed: 500,
                    on: {
                        init: function (swiper) {
                            if (thumbsDirection === 'horizontal') {
                                const slides = $('#gallery-thumbs .swiper-slide');
                                if (slides.length > thumbsSlidesPerView) {
                                    $('#gallery-thumbs .prodigy-product__gallery-nav').show();
                                    initNav(swiper, $('#gallery-thumbs'));
                                }
                            } else if (thumbsDirection === 'vertical') {
                                let slidesHeight = 0;
                                let mainHeight = $('#gallery-main').outerHeight();
                                swiper.slides.forEach(
                                    slide => {
                                        slidesHeight += $(slide).outerHeight();
                                    },
                                );
                                if (slidesHeight > mainHeight) {
                                    $('#gallery-thumbs .prodigy-product__gallery-nav').show();
                                    initNav(swiper, $('#gallery-thumbs'));
                                }
                            }
                        },
                    },
                },
            );

            this.swiperMain = new Swiper(
                '#gallery-main',
                {
                    speed: 500,
                    pagination: {
                        el: '.prodigy-product__gallery-count',
                        type: 'fraction',
                    },
                    thumbs: {
                        swiper: $('#gallery-thumbs').length ? this.swiperThumbs : null,
                    },
                    on: {
                        init: function (swiper) {
                            const slides = $('#gallery-main .swiper-slide');
                            if (slides.length > 1) {
                                $('#gallery-main .prodigy-product__gallery-nav').show();
                                initNav(swiper, $('#gallery-main'));
                            }
                        },
                    },
                },
            );

            if (typeof code_happened === 'undefined' || window.code_happened == false) {
                window.code_happened = true;

                $(document).on(
                    'click',
                    '.icon-fullscreen-js',
                    this.open_photo_swipe.bind(this),
                );
            }
        },

        get_gallery_images: function () {
            const slides = $('#gallery-main .prodigy-product__gallery-img svg');
            let items = [];

            if (slides.length) {
                slides.each(function (i, el) {
                    // Use the outerHTML of the SVG
                    const svgOuterHTML = el.outerHTML;

                    // Create a PhotoSwipe item object
                    const item = {
                        html: svgOuterHTML, // Use `html` to display SVG as content
                        w: 800, // Default width
                        h: 1000, // Default height
                    };

                    items.push(item);
                });
            }

            return items;
        },

        open_photo_swipe: function (e) {
            e.preventDefault();

            var pswpElement = $('.pswp')[0],
                items = this.get_gallery_images(),
                index = $('#gallery-main .swiper-slide-active').index();

            var options = $.extend(
                {
                    index: index,
                    addCaptionHTMLFn: function (item, captionEl) {
                        if (item.html) {
                            captionEl.children[0].innerHTML = item.title || '';
                            return true;
                        }
                        return false;
                    },
                },
                {},
            );

            // Initializes and opens PhotoSwipe.
            var photoswipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            photoswipe.init();
        },


        set_gallery: function (slugs, attribute) {
            this.is_variant_gallery = true;
            let option_attributes = [];
            let option_images = '';
            let product_options = JSON.parse($('#product-options-data-js').val());
            $.each(product_options, function (i) {
                for (k in slugs) {
                    if (attribute === i) {
                        option_attributes.push(product_options[i][slugs[k].name]);
                    }
                }
            });

            let images = [];
            for (let k in option_attributes) {
                if (!option_attributes[k] || typeof option_attributes[k].images === 'undefined') {
                    return false;
                }
                option_attributes[k].images.forEach(image => images.push(image));
            }

            if (images.length > 0) {
                // Remove event handlers before destroying Swipers
                $('#gallery-main').off('click', '.prodigy-product__gallery-nav-prev');
                $('#gallery-main').off('click', '.prodigy-product__gallery-nav-next');
                if (this.is_gallery_thumbnails()) {
                    $('#gallery-thumbs').off('click', '.prodigy-product__gallery-nav-prev');
                    $('#gallery-thumbs').off('click', '.prodigy-product__gallery-nav-next');
                }
                
                // Destroy existing Swipers before rebuilding
                if (this.swiperMain) {
                    this.swiperMain.destroy(true, true);
                }
                if (this.is_gallery_thumbnails() && this.swiperThumbs) {
                    this.swiperThumbs.destroy(true, true);
                }

                // Clear slides containers
                $('#gallery-main .swiper-wrapper').empty();
                if (this.is_gallery_thumbnails()) {
                    $('#gallery-thumbs .swiper-wrapper').empty();
                }

                for (let i in images) {
                    const attributes = images[i].attributes;
                    const image_url = attributes['cropped-url'];
                    const thumbnail_url = attributes['cropped-url'];
                    let width = 0;
                    let height = 0;
                    let view_box = '0 0 800 1000';

                    if (typeof attributes['cropping-params'] !== undefined && attributes['cropping-params'] !== null) {
                        width = typeof attributes['cropping-params']['w'] !== undefined ? parseInt(attributes['cropping-params']['w']) : 0;
                        height = typeof attributes['cropping-params']['h'] !== undefined ? parseInt(attributes['cropping-params']['h']) : 0;
                        view_box = width > 0 && height > 0 ? '0 0 ' + width + ' ' + height : '0 0 800 1000';
                    }

                    const large_img = attributes.versions['large_retina'] ? attributes.versions['large_retina'] : '';

                    let current_image_id = images[i].id;
                    $('#gallery-main .swiper-wrapper').append(this.prepare_main_slider_slide(
                        current_image_id,
                        image_url,
                        view_box,
                        width,
                        height,
                        large_img,
                    ));
                    if (this.is_gallery_thumbnails()) {
                        $('#gallery-thumbs .swiper-wrapper').append(this.prepare_thumbnail_slider_slide(current_image_id, thumbnail_url, view_box));
                    }
                }
            } else {
                this.restore_default_image_gallery();
            }

            if (option_attributes.images && typeof option_attributes[k].images[0] !== 'undefined') {
                option_images = option_attributes[k].images[0].attributes;
            }

            // Reinitialize gallery with new slides count
            this.set_product_gallery(images.length);

            if (option_attributes.images && typeof option_attributes[k].images[0] !== 'undefined') {
                $('.swiper-slide-active').find('.main-gallery-image-js').attr('href', option_images['cropped-url']);
            }
        },

        is_gallery_thumbnails: function () {
            return $('#gallery-thumbs').length > 0;
        },

        restore_default_image_gallery: function () {
            let images = $('#gallery-main').data('images');
            if (images.length !== 0) {
                this.swiperMain.removeAllSlides();
                this.swiperThumbs.removeAllSlides();
                for (i in images) {
                    const image_url = images[i]['cropped-url'];
                    const thumbnail_url = images[i].versions['thumbnails'];
                    let view_box = '';

                    if (typeof images[i]['cropping-params'] !== 'undefined' && images[i]['cropping-params'] !== null) {
                        let width = typeof images[i]['cropping-params']['w'] !== 'undefined' ? images[i]['cropping-params']['w'] : 0;
                        let height = images[i]['cropping-params']['h'] ? images[i]['cropping-params']['h'] : 0;
                        view_box = height && width ? '0 0 ' + width + ' ' + height : '';
                    }

                    this.swiperMain.appendSlide(this.prepare_main_slider_slide(images[i].id, image_url, view_box));
                    this.swiperThumbs.appendSlide(this.prepare_thumbnail_slider_slide(images[i].id, thumbnail_url, view_box));
                }
            }
        },


        prepare_main_slider_slide: function (current_image_id, image_url, view_box = null, width = null, height = null, large_img = null) {
            let clone = $(this.main_slider_template).contents().clone();
            let svg = clone.find('.main-gallery-image-js').parent();
            let img = clone.find('img');

            if (width > 0) {
                img.attr('data-large_image_width', width);
            }
            if (height > 0) {
                img.attr('data-large_image_height', height);
            }
            if (large_img) {
                img.attr('data-large_image', large_img);
            }

            clone.find('.main-gallery-image-js').attr('href', image_url);
            clone.find('.main-gallery-image-js').attr('data-image-id', current_image_id);

            if (view_box) {
                svg.attr('viewBox', view_box);
            }
            return clone;
        },

        prepare_thumbnail_slider_slide: function (current_image_id, image_url, view_box) {
            let clone = $(this.thumb_slider_template).contents().clone();
            clone.find('image.thumb-gallery-image-js').attr('href', image_url);
            clone.find('image.thumb-gallery-image-js').attr('data-image-id', current_image_id);
            clone.find('svg').attr('viewBox', view_box);

            return clone;
        },

    };

    window.prodigyProductGallery = prodigy_product_gallery;
    })(jQuery, window);

    jQuery(document).ready(
        function ($) {
            window.prodigyProductGallery.init();
        }
    );
